define([
	"dojo/_base/declare",
	"csi",
	"csi/table/Delete",
	"csi/xml"
], function(declare,csi,Delete,xml) {

	return declare(Delete,{
		toWriter: function() {
			this.m_writer.changeNode(this.m_urlNode).changeAttribute("InspirationTheme", xml.ATTR_REF, csi.EMPTY_URL);
		}
	});
});